export enum roleType {
  ADMIN = 'admin',
  OPERATOR = 'operator',
  NONE = 'none',
}
